// extracted by mini-css-extract-plugin
export default {"line":"resize_line__FY7e5","active":"resize_active__lJAWc"};